/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface HelpDataSiteCalc
 */
export interface HelpDataSiteCalc {
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  tarif?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  tm_type?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  need_check?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  term?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  media_type?: string
  /**
   *
   * @type {string}
   * @memberof HelpDataSiteCalc
   */
  mktu_count?: string
  /**
   *
   * @type {number}
   * @memberof HelpDataSiteCalc
   */
  total_sum?: number
}

/**
 * Check if a given object implements the HelpDataSiteCalc interface.
 */
export function instanceOfHelpDataSiteCalc(
  value: object
): value is HelpDataSiteCalc {
  return true
}

export function HelpDataSiteCalcFromJSON(json: any): HelpDataSiteCalc {
  return HelpDataSiteCalcFromJSONTyped(json, false)
}

export function HelpDataSiteCalcFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpDataSiteCalc {
  if (json == null) {
    return json
  }
  return {
    tarif: json['tarif'] == null ? undefined : json['tarif'],
    tm_type: json['tm_type'] == null ? undefined : json['tm_type'],
    need_check: json['need_check'] == null ? undefined : json['need_check'],
    term: json['term'] == null ? undefined : json['term'],
    media_type: json['media_type'] == null ? undefined : json['media_type'],
    mktu_count: json['mktu_count'] == null ? undefined : json['mktu_count'],
    total_sum: json['total_sum'] == null ? undefined : json['total_sum'],
  }
}

export function HelpDataSiteCalcToJSON(value?: HelpDataSiteCalc | null): any {
  if (value == null) {
    return value
  }
  return {
    tarif: value['tarif'],
    tm_type: value['tm_type'],
    need_check: value['need_check'],
    term: value['term'],
    media_type: value['media_type'],
    mktu_count: value['mktu_count'],
    total_sum: value['total_sum'],
  }
}
